import { FC, Fragment } from "react";
import type { EventContent as EventContentItem } from "src/state/AppointmentsBloc/AppointmentsBloc";
import SanityBlockContent from "src/ui/components/SanityBlockContent/SanityBlockContent";
import { EventContent, EventContentTitle } from "./AppointmentDialog.styled";

const AppointmentEventContent: FC<{ sections: EventContentItem[] }> = ({
  sections
}) => {
  return (
    <>
      {sections.map((section) => (
        <Fragment key={section._key}>
          <EventContentTitle>{section.contentTitle}</EventContentTitle>
          <EventContent>
            <SanityBlockContent blocks={section.content} />
          </EventContent>
        </Fragment>
      ))}
    </>
  );
};

export default AppointmentEventContent;
